module.exports = __webpack_public_path__ + "static/img/bg_3.c97500fe.jpg";